// extracted by mini-css-extract-plugin
export default {"inputNumber":"InputNumber_inputNumber__afaSf","small":"InputNumber_small__HvbVF","middle":"InputNumber_middle__NAqWE","large":"InputNumber_large__e2c2r"};